export default __webpack_public_path__ + "static/media/vancouver.f63ad4b1.jpg";